<template>
    <Card>
        <div>
            <div class="sousuo" style="width: 100%">
                <div style="width: 450px" class="yl-flex flex_between">
                    <Input placeholder="搜索客户姓名/电话" v-model="name" style="width: 300px">
                        <i-button slot="append" icon="ios-search"></i-button>
                    </Input>
                    <Button class='ivu-btn-circle' type="primary" @click="getList">搜索</Button>
                    <Button class='ivu-btn-circle' @click="initSearch">重置</Button>
                </div>
            </div>
            <div class="multiple">
                <div class="child-div">时间区间</div>
                <RadioGroup v-model="timePeriod">
                    <Radio label="0"><span>不限</span></Radio>
                    <Radio label="1"><span>今日</span></Radio>
                    <Radio label="2"><span>昨日</span></Radio>
                    <Radio label="3"><span>本周</span></Radio>
                    <Radio label="4"><span>上周</span></Radio>
                    <Radio label="5"><span>本月</span></Radio>
                    <Radio label="6"><span>上月</span></Radio>
                    <Radio label="7"><span>自定义</span></Radio>
                    <DatePicker v-show="timePeriod == '7' " :value="timePeriodDate" @on-change="timePeriodDateChange"
                                type="daterange"
                                placeholder="选择日期" style="width: 200px"></DatePicker>
                </RadioGroup>
            </div>
            <div class="multiple">
                <div class="child-div">所属部门</div>
                <Select v-model="department" style="width:200px">
                    <Option v-for="item in departmentList" :value="item.value" :key="item.value">{{ item.label }}
                    </Option>
                </Select>
            </div>
            <div class="multiple">
                <div class="child-div">签约状态</div>
                <Select v-model="status" style="width:200px">
                    <Option v-for="item in status_list" :value="item.value" :key="item.value">{{ item.label
                        }}
                    </Option>
                </Select>
            </div>
            <div style="width: 100% ;margin-top: 20px;">
                <Table :columns="columns" :data="datas" size="small" ref="table">
                    <template slot-scope="{ row }" slot="name">
						<div style="display: flex; align-items: center;">
							<div v-if="row.type == 1 "
								 style="text-align: center;width: 20px; height: 20px; line-height: 20px; background-color: #14BD98; color: #FFFFFF; border-radius: 50%;">
								个
							</div>
							<div v-if="row.type == 2 "
								 style="text-align: center;width: 20px; height: 20px; line-height: 20px; background-color: #0C92F4; color: #FFFFFF; border-radius: 50%;">
								企
							</div>
							<div style="display: flex;flex-direction: column; align-items: center;">
								<span>{{row.name}}</span>
								<span>{{row.phone}}</span>
							</div>
						</div>
                    </template>
					<template slot-scope="{ row }" slot="operation">
						<div
							style="display: flex; flex-direction: column; align-items: center;justify-content: space-around; height: 100px;">
							<span style="color: #2A8BF6; cursor: pointer;" :data-contract_id="row.id" @click.stop="contractManage">查看签约</span>
							<span style="color: #2A8BF6; cursor: pointer;" :data-contract_id="row.id" v-if="row.status == 1" @click.stop="pass">审核通过</span>
							<span style="color: #555500; cursor: pointer;" :data-contract_id="row.id" v-if="row.status == 1" @click.stop="refuse">审核拒绝</span>
							<span style="color: #555500; cursor: pointer;" :data-contract_id="row.id"
								:data-client_id="row.id" @click.stop="delContract">作废</span>
						</div>
					</template>
                </Table>
            </div>
            <div class="pager">
                <Page :total="count" :page-size="20" :current="page" @on-change="changePage" size="small"
                      show-elevator/>
            </div>
			<Modal v-model="checkContractModal">
				<Upload ref="upload" :onlyRead="true"></Upload>
			</Modal>
			<!-- 查看签约管理 -->
			<Modal v-model="modal" width="900">
				<ContractDetail :contractId="contractId"></ContractDetail>
				<div slot="footer">
					<Button type="default" @click="modal = false">取消</Button>
				</div>
			</Modal>
        </div>
    </Card>
</template>
<script>
	import {
		getContractList,passContract,refuseContract
	} from '@/api/finance'
	import Upload from '../tool/Upload.vue';
	import ContractDetail from '../task/ContractDetail.vue';
	import {mapGetters} from "vuex";
	import {getDepartmentList} from "../../api/user";
	import {delContract} from "../../api/client.js"
    export default {
        name: "ContractExamine",
        components: {
		Upload,
		ContractDetail
		},

        data() {
            return {
				checkContractModal: false,
				modal:false,
                count: 0,
                page: 1,
                name: '',
                timePeriod: '0',
                timePeriodDate: [],
                department: '0',
				contractId:0,
                departmentList: [],
                status: '0',
                status_list: [
                    {
                        value: -1,
                        label: '未通过'
                    },
					{
						value: -2,
						label: '拒绝'
					},
					{
						value: 1,
						label: '已通过'
					}
                ],
                datas: [
                ],
				imgList: [],
                columns: [
                    {
                        "title": "姓名",
                        "key": "name",
                        width: '130',
						align: 'center'
                    },
					{
					    "title": "电话号码",
					    "key": "phone",
					    width: '130',
						align: 'center'
					},
                    {
                        "title": "媒体代码",
                        "key": "media_name",
						align: 'center'
                    },
					{
					    "title": "所属员工",
					    "key": "sign_name",
						align: 'center'
					},
                    {
                        "title": "所属部门",
                        "key": "department_name",
						align: 'center'
                    },
                    {
                        "title": "签约日期",
                        "key": "created_at",
						align: 'center'
                    },
                    {
                        "title": "申请额度",
                        "key": "loans_money",
						align: 'center'
                    },
                    {
                        "title": "签约费率",
                        "key": "rate",
						align: 'center'
                    },
                    {
                        "title": "诚意金",
                        "key": "sincerity_money",
						align: 'center'
                    },
                    {
                        "title": "合同号",
                        "key": "contract_number",
						align: 'center'
                    },
					{
					    "title": "财务审核状态",
					    "key": "sign_status",
						align: 'center'
					},
                    {
                        "title": "操作",
                        "slot": "operation",
						align: 'center'
                    }
                ],
            }
        },
		mounted: function () {
			this.loadData();
			this.getList();
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
        methods: {
			timePeriodDateChange(e) {
				this.timePeriodDate = e
			},
			initSearch() {
				this.name = '';
				this.department = 0;
				this.status = 0;
				this.timePeriod = 0;
				this.timePeriodDate = [];
			},
			async loadData() {
				let that = this;
				that.initSearch();
				var data = {token: this.token};
				var res = await getDepartmentList(that, data);
				if (res.code == 1) {
					that.departmentList = res.data.list;
				}
			},
			contractManage(e) {
				let that = this;
				that.contractId = e.currentTarget.dataset.contract_id;
				that.modal = true;
			},
			async delContract(e) {
				let that = this;
				let contract_id = e.currentTarget.dataset.contract_id;
				this.$Modal.confirm({
					title: '确认要作废该签约合同吗？',
					onOk: async () => {
						let res = await delContract(that, {
							token: that.token,
							contract_id: contract_id
						});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.getList();
						}
					}
				})
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			async getList() {
				let that = this;
				var data = this.$data;
				data.token = this.token;
				data.page = this.page;
				let res = await getContractList(that, data);
				that.datas = res.data.list;
				that.count = res.count;
			},
			search() {
				this.page = 1;
				this.getList();
			},
			checkContract(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				this.datas.forEach(function (row) {
					if (row.id == id) {
						that.$refs['upload'].uploadList = row.ext_info.imgList
					}
				})
				that.checkContractModal = true;
			},
			pass(e) {
				let that = this;
				let id = e.currentTarget.dataset.contract_id;
				this.$Modal.confirm({
					title: '确认通过吗？',
					onOk: async () => {
						let res = await passContract(that, {token: that.token, id: id});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.getList();
						}
					}
				})
			},
			refuse(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				this.$Modal.confirm({
					title: '确认拒绝吗？',
					onOk: async () => {
						let res = await refuseContract(that, {token: that.token, id: id});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.getList();
						}
					}
				})
			}
        },

    }
</script>
<style scoped lang="less">

    .yellow_btn {
        color: #F8BD66;
    }

    .multiple {
        display: flex;
        justify-content: left;
        margin-top: 10px;
        align-items: center;

        .child-div {
            width: 70px;
            height: 20px;
            margin-right: 30px;
            text-align-last: justify;
        }
    }


    .sousuo {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

    .yl-flex {
        display: flex;
    }

    .flex_between {
        align-items: flex-start;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }
</style>
